var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_11353)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1708 26.8057C12.573 27.2785 13.0732 27.6583 13.6367 27.9188C14.2002 28.1792 14.8135 28.3142 15.4343 28.3143H27.34C28.4767 28.3143 29.5668 27.8627 30.3705 27.059C31.1742 26.2553 31.6258 25.1652 31.6258 24.0286V15.9714C31.6258 14.8348 31.1742 13.7447 30.3705 12.941C29.5668 12.1372 28.4767 11.6857 27.34 11.6857H15.4343C14.8135 11.6858 14.2002 11.8207 13.6367 12.0812C13.0732 12.3417 12.573 12.7215 12.1708 13.1943L8.74218 17.2228C8.08218 17.9981 7.71973 18.9829 7.71973 20.0011C7.71973 21.0192 8.08218 22.004 8.74218 22.7793L12.1708 26.8078V26.8057Z",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7079 16.115L25.3879 23.795",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3858 16.115L17.7101 23.795",
    stroke: "#5C5C5C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_11353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteNote);
export default __webpack_public_path__ + "static/media/delete-note.6304d0d971221ba8839e1126b19157e9.svg";
export { ForwardRef as ReactComponent };